export default __webpack_public_path__ + "static/media/InterviewFresherIcons.ab32b20d.svg";